import React from 'react';

const FREE_FEATURES = [
  'Search all watches by brand, model & ref',
  'Market price, trade value & insurance',
  'Instant appraisal tool',
  'Basic price history',
  'Brand & year filters',
];

const PRO_FEATURES = [
  'Everything in Free',
  'Portfolio tracker — synced across devices',
  'Full 12-month price history charts',
  'Price alerts via email',
  'Export appraisals as PDF',
  'Live prices via eBay market data',
  'Priority support',
];

const DEALER_FEATURES = [
  'Everything in Pro',
  'Bulk watch lookups — unlimited',
  'Branded PDF appraisal certificates',
  'Dealer trade offer calculations',
  'CSV export for inventory',
  'API access for your own systems',
  'White-label appraisal reports',
  'Dedicated account manager',
  'Early access to new features',
];

const card = {
  background: 'var(--surface)',
  border: '0.5px solid var(--border)',
  borderRadius: 'var(--radius-lg)',
  padding: 28,
  display: 'flex',
  flexDirection: 'column',
};

export default function PricingPage() {
  return (
    <div style={{ position: 'relative', zIndex: 1, maxWidth: 960, margin: '0 auto', padding: 'clamp(24px,5vw,48px) clamp(12px,4vw,20px)' }}>
      <div style={{ textAlign: 'center', marginBottom: 44 }}>
        <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(24px,4vw,32px)', fontWeight: 700, marginBottom: 8, letterSpacing: '-0.02em' }}>
          Simple, transparent pricing
        </h1>
        <p style={{ fontSize: 15, color: 'var(--text2)' }}>Start free. Upgrade when you're ready.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 18, alignItems: 'start' }}>

        {/* FREE */}
        <div style={{ ...card }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 10, fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '0.04em', textTransform: 'uppercase' }}>Free</div>
          <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 38, fontWeight: 700, marginBottom: 2 }}>$0</div>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 22 }}>Forever free · No card needed</div>
          <div style={{ padding: '10px', borderRadius: 8, border: '0.5px solid var(--border)', background: 'var(--surface2)', color: 'var(--text2)', fontSize: 13, textAlign: 'center', marginBottom: 24, fontFamily: "'Space Grotesk', sans-serif" }}>
            Current plan
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {FREE_FEATURES.map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: 'var(--text2)' }}>
                <i className="ti ti-check" style={{ color: 'var(--up)', marginTop: 2, flexShrink: 0 }} /> {f}
              </div>
            ))}
          </div>
        </div>

        {/* PRO */}
        <div style={{ ...card, border: '1.5px solid var(--market)', position: 'relative' }}>
          <div style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', fontSize: 10, fontWeight: 700, padding: '3px 12px', borderRadius: 99, background: 'var(--market)', color: '#fff', letterSpacing: '0.07em', whiteSpace: 'nowrap' }}>
            MOST POPULAR
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--market)', marginBottom: 10, fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '0.04em', textTransform: 'uppercase' }}>Pro</div>
          <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 38, fontWeight: 700, marginBottom: 2 }}>
            $19.99<span style={{ fontSize: 16, fontWeight: 400, color: 'var(--text2)' }}>/mo</span>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 22 }}>Billed monthly · Cancel anytime</div>
          <button
            onClick={() => alert('Payments coming soon! Email Levdar10475@gmail.com for early access.')}
            style={{
              padding: '11px', borderRadius: 8, border: 'none',
              background: 'linear-gradient(135deg, #C0392B, #96281B)',
              color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              fontFamily: "'Space Grotesk', sans-serif", marginBottom: 24,
              boxShadow: '0 4px 14px rgba(192,57,43,0.3)',
            }}>
            Upgrade to Pro
          </button>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {PRO_FEATURES.map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: 'var(--text)' }}>
                <i className="ti ti-check" style={{ color: 'var(--market)', marginTop: 2, flexShrink: 0 }} /> {f}
              </div>
            ))}
          </div>
        </div>

        {/* DEALER PRO */}
        <div style={{ ...card, background: 'var(--surface)', border: '1.5px solid #c9a227', position: 'relative' }}>
          <div style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', fontSize: 10, fontWeight: 700, padding: '3px 12px', borderRadius: 99, background: '#c9a227', color: '#fff', letterSpacing: '0.07em', whiteSpace: 'nowrap' }}>
            FOR DEALERS
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, color: '#a07c10', marginBottom: 10, fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '0.04em', textTransform: 'uppercase' }}>Dealer Pro</div>
          <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 38, fontWeight: 700, marginBottom: 2 }}>
            $99<span style={{ fontSize: 16, fontWeight: 400, color: 'var(--text2)' }}>/mo</span>
          </div>
          <div style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 22 }}>Per location · Billed monthly</div>
          <button
            onClick={() => window.location.href = 'mailto:Levdar10475@gmail.com?subject=Dial Market Dealer Pro Inquiry'}
            style={{
              padding: '11px', borderRadius: 8, border: 'none',
              background: 'linear-gradient(135deg, #c9a227, #8a6c10)',
              color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              fontFamily: "'Space Grotesk', sans-serif", marginBottom: 24,
              boxShadow: '0 4px 14px rgba(201,162,39,0.3)',
            }}>
            Contact for Dealer Access
          </button>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {DEALER_FEATURES.map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: 'var(--text)' }}>
                <i className="ti ti-check" style={{ color: '#c9a227', marginTop: 2, flexShrink: 0 }} /> {f}
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Bottom note */}
      <div style={{ marginTop: 40, textAlign: 'center', fontSize: 13, color: 'var(--text3)' }}>
        Questions? Email us at{' '}
        <a href="mailto:Levdar10475@gmail.com" style={{ color: '#C0392B', fontWeight: 500 }}>
          Levdar10475@gmail.com
        </a>
      </div>
    </div>
  );
}
